import React from "react";
import { Link, NavLink } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setMenuSelection } from "../../../../storage/reducers/menuSelectorReducer";
import { utilAnalytics } from "../../../common/analytics/analyticsUtil";
import "./PreflightMenu.scss";
import { aerospaceUrl, fmsGuidedVisualsUrl, LOCATION_BREADCRUMB, newsletterDirectToUrl, preflightMenuOptions, rnpInstrumentApproachesUrl } from "../../../../helper/constants";
import { useTranslation } from "react-i18next";
import {ReactComponent as ExternalLinkIcon} from "./ExternalLink.svg";
import { capitalize } from "../../../../helper/commonFunctions";

const PreflightMenu = () => {
  const {VirtualclassroomsText, Virtualclassrooms, Engines, RNPProcedures, FMSVisuals, Articles} = preflightMenuOptions;
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const setMenuOptionSelected = (option: string, title:string) => {
    dispatch(
      setMenuSelection({
        currentMenuSelection: option,
        currentMenuTitle: title
      })
    );
  };

  const menuSelectedOption = useSelector(
    (state: any) => state?.menuSelector?.currentMenuSelection
  );

  const handleMenuSelection = (option: string, title:string) => {
    setMenuOptionSelected(option, title);
  };

  return (
    <>
      <nav>
        <div className="topline"></div>
        <ul className="menu">
            <li className={menuSelectedOption === `/${Virtualclassrooms}` ? "active":""}>
                <NavLink 
                    to={`/${Virtualclassrooms}`}
                    className={() => ""}
                    onClick={() => {
                        handleMenuSelection(`/${Virtualclassrooms}`, `${VirtualclassroomsText}`); 
                        utilAnalytics(true, { linkName: `${VirtualclassroomsText}` }, `/${Virtualclassrooms}`);
                    }}
                    >{t(LOCATION_BREADCRUMB.VIRTUAL_CLASSROOMS)}</NavLink>
            </li>

            <li className={menuSelectedOption === `/${Engines}` ? "active":""}>
                <NavLink 
                to={`/${Engines}`}
                className={() => ""}
                onClick={() => {
                    handleMenuSelection(`/${Engines}`, `${capitalize(Engines)}`);
                    utilAnalytics(true, { linkName: capitalize(Engines) }, `/${Engines}`);
                }}
                >{t(LOCATION_BREADCRUMB.ENGINES)}</NavLink>
            </li>

            {/* NEW-TAB LINK — do NOT dispatch title/menu selection change.
                Opening in a new tab must never alter the current tab's page title. */}
            <li className={menuSelectedOption === `${FMSVisuals}` ? "active":""}>
                <a 
                href={fmsGuidedVisualsUrl}
                target="_blank"
                className="punchout"
                onClick={() => {
                    utilAnalytics(true, { linkName: `${fmsGuidedVisualsUrl}` }, aerospaceUrl);
                }}
                >
                {t(LOCATION_BREADCRUMB.FMS_VISUALS)} <ExternalLinkIcon className="iconPreflightMenu" />
                </a>
            </li>

            {/* NEW-TAB LINK — do NOT dispatch title/menu selection change. */}
            <li className={menuSelectedOption === `${RNPProcedures}` ? "active":""}>
                <a 
                href={rnpInstrumentApproachesUrl} 
                target="_blank"
                className="punchout"
                onClick={() => {
                    utilAnalytics(true, { linkName: `${rnpInstrumentApproachesUrl}` }, aerospaceUrl);
                }}
                >
                {t(LOCATION_BREADCRUMB.RNP_PROCEDURES)} <ExternalLinkIcon className="iconPreflightMenu" />
                </a>
            </li>

            {/* NEW-TAB LINK — do NOT dispatch title/menu selection change. */}
            <li className={menuSelectedOption === `${Articles}` ? "active":""}>
                <a 
                href={newsletterDirectToUrl}
                target="_blank"
                className="punchout"
                onClick={() => {
                    // handleMenuSelection(`${Articles}`, `${Articles}`);
                    utilAnalytics(true, { linkName: `${newsletterDirectToUrl}` }, aerospaceUrl);
                }}
                >
                {t(LOCATION_BREADCRUMB.NEWSLETTERS)} <ExternalLinkIcon className="iconPreflightMenu" />
                </a>
            </li>
        </ul>
      </nav>
    </>
  );
};

export default PreflightMenu;